





















































































































import { Component, Vue, Prop, Watch, PropSync } from "vue-property-decorator";
import * as cropsService from "@/services/crops";
import { CropsDTO } from "@/api/crops/types";
import { CropType } from "@/constants/crop-type";
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import i18n from "@/i18n";
import { roundedWithFrac } from "@/filters/scalar";
import { formattedYield } from "@/filters/yield";
import { formattedAreaInHa } from "@/filters/area";
import { formattedDate } from "@/filters/date";
import AgroTimeLine from "@/components/agroTimeLine/AgroTimeLine.vue";
import CropIcons from "@/utils/iconCropTypes";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { VBTooltip } from 'bootstrap-vue';
import * as notificationService from "@/services/notification";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import MonitoringStatus from "@/views/monitoring/components/monitoring-status/MonitoringStatus.vue";
import HarvestDataEditor from "@/components/harvestDataEditor/HarvestDataEditor.vue";

@Component({
  name: "CropsTableController",
  components: {
    MonitoringStatus,
    CropsTable: AgroResponsiveTable,
    AgroTimeLine,
    AgroIcons,
    ConfirmationModal,
    HarvestDataEditor,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  filters: {
    roundedWithFrac,
    formattedYield,
    formattedAreaInHa,
    formattedDate,
  },
})
export default class CropsTableController extends Vue {
  @Prop({ type: String, default: "" })
  private farmAnalysisUuid!: string;

  @Prop({ type: String, default: null })
  private hovered!: string | null;

  @Prop({ type: Boolean, default: false })
  private completed!: boolean;

  @PropSync("selected", { type: Array, default: () => [] })
  private selectedCrops!: string[];

  @Prop({ type: String, default: "SUMMER" }) 
  private harvestSeason!: string;

  @Prop({ type: String, default: "SOY" })
  private cropType!: string;

  @Prop({ type: Boolean, default: false })
  private unified!: boolean;

  private stateSynced!: string;

  private columnsLabel: object = {};
  
  private cropToReset?: any = null;

  private tableColumns = [
    { name: "select", sortedBySelected: true },
    { name: "cropType" },
    { name: "cropLabel" },
    { name: "area" },
    { name: "yield" },
    // { name: "seeding-date" },
    // { name: "estimated-harvest-date" },
    { name: "cropStages" },
    { name: "info", sortable: false },
  ];

  private prefix: string = "monitoring";

  @Watch("completed", { immediate: true })
  private async onCompleted() {
    await this.getCrops(this.farmAnalysisUuid);
  }

  private get isAdminUser() {
    return this.$store.getters['user/isAdminUser'];
  }

  private checkCrospsStageEmpty(cropStages: any) {
    return cropStages;
  }
  
  private async resetCrop() {
    if (this.cropToReset) {
      await cropsService.resetCrop(this.cropToReset.cropUuid);
      this.cropToReset = null;
      notificationService.addSuccessNotification(i18n.t('monitoring.crop-reset.success',) as string);
    }
  }

  private created() {
    this.columnsLabel = {
      select: "select",
      cropType: i18n.t("compare-farms-owners.analysis-year"),
      cropLabel: "label",
      area: i18n.t("compare-farms-owners.analysis-year"),
      yield: i18n.t("compare-farms-owners.analysis-year"),
      // seedingDate: i18n.t("compare-farms-owners.analysis-year"),
      // estimatedHarvestDate: i18n.t("compare-farms-owners.analysis-year"),
      cropStages: i18n.t("compare-farms-owners.analysis-year"),
      plotDoctorStatus: i18n.t("compare-farms-owners.analysis-year"),
    };
  }

  private async mounted() {
    await this.getCrops(this.farmAnalysisUuid);
  }

  private get getCropsStatus() {
    return this.$store.state.crops.status;
  }

  private get cropsList() {
    return this.$store.getters[`crops/crops`](this.farmAnalysisUuid);
  }

  private get selectedCropsSet() {
    return new Set(this.selectedCrops);
  }

  // SENTINELA: análise unificada permite toda a lista (null = sem restrição);
  // não unificada permite mudar para a própria cultura da análise ou UNKNOWN
  // (para marcar o talhão como indeterminado).
  private get allowedCropTypes(): string[] | null {
    return this.unified ? null : [this.cropType, CropType.UNKNOWN];
  }

  private get selectedCropsData(): CropsDTO[] {
    const selected = new Set(this.selectedCrops.map(String));
    return (this.cropsList || [])
      .flat()
      .filter((crop: CropsDTO) => selected.has(String(crop.cropLabel)));
  }

  private onHarvestSaved() {
    // O recálculo de scores/summary é assíncrono; reconsulta após alguns segundos.
    setTimeout(() => {
      this.getCrops(this.farmAnalysisUuid);
    }, 4000);
  }

  private async getCrops(farmAnalysisUuid: string) {
    cropsService.getCropsByFarmAnalysisUuid(farmAnalysisUuid, this.harvestSeason, this.cropType);
    this.stateSynced = "fetching:crops";
  }

  private isRowHighlighted(crop: CropsDTO) {
    return crop.cropUuid === this.hovered;
  }

  private cropTypeIconName(item: string) {
    return CropIcons.fromText(item);
  }
}
